import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { Module } from 'src/app/models/common';
import { AvailableProductsComponent } from '../../available-products/available-products.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-program-view-modal',
  templateUrl: './program-view-modal.component.html',
  styleUrls: ['./program-view-modal.component.scss']
})
export class ProgramViewModalComponent implements OnInit {

  formFields;
  programForm: UntypedFormGroup;
  strflag: string = null;
  content: any;
  heading: string;
  modulelist: any[] = [];
  productlist: any = [];
  MappedItems: any = [];
  action: Subject<any> = new Subject();
  isautocode: boolean = false;
  IsProductChecked: boolean = false;
  // IsButtonEnable: boolean = true;
  IsISTChecked: boolean = false;
  IsEAPChecked: boolean = false;
  ISGRANTSChecked: boolean = false;
  isreferenced:boolean=false;
  Pro_Id: any;
  Isdisabled: boolean = false;
  @Input() public Content: any;



  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.getModulesList();
    this.availableProducts();
    this.programForm = new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        CODE: new UntypedFormControl("", [Validators.required, Validators.maxLength(25)]),
        NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
        DESCRIPTION: new UntypedFormControl("", [Validators.required, Validators.maxLength(255)]),
        IS_FUND_SUPPORT: new UntypedFormControl(false),
        IS_PRODUCT_SUPPORT: new UntypedFormControl(false),
        PROGRAM_ID: new UntypedFormControl("", [Validators.required]),
        PRODUCT_ID: new UntypedFormControl([], [Validators.required]),
        ACTIVECHECK: new UntypedFormControl(true),
        MAPPED_PRODUCTS: new UntypedFormControl([]),
      });

    if (this.Content.heading == "View") {
      this.GetEditData();
      this.programForm.disable();
      this.programForm.controls['PRODUCT_ID'].disable();
      
    }
    if (this.Content.heading == "Edit") {
      this.GetEditData();
     
    }
    if (this.Content.heading == "Add") {
      this.programForm.controls['PRODUCT_ID'].disable();
    }
  }

  availableProducts() {
      this.summaryService.getSummaryData('api/AdminProgram/GetProductsAvaliable?RecordID='+ this.Content.content.id).subscribe((result) => {
        this.productlist = result;
        this.productlist.forEach((item : any ) => 
        {
          if(item.IsActive == false)
          item["icon"]="ieg_inactive_record";
        })

        //this.productlist=[{label : "Select all" , value: ""}].concat(this.productlist);
      });
  }



  public setProgramOption(Pro_Id) {
    if (Pro_Id == 2) {
      this.IsISTChecked = true;
      this.IsEAPChecked = false;
      this.ISGRANTSChecked = false;
    }
    if (Pro_Id == 5) {
      this.IsEAPChecked = true;
      this.IsISTChecked = false;
      this.ISGRANTSChecked = false;
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(true);
      this.Isdisabled = true;
    }
    if (Pro_Id == 4) {
      this.ISGRANTSChecked = true;
      this.IsISTChecked = false;
      this.IsEAPChecked = false;
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(true);
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(false);
      this.Isdisabled = true;
    }

  }

  public onOptionsSelected(event) {
    // console.log(event, event.target.value);
    this.programForm.controls['IS_PRODUCT_SUPPORT'].enable();
    this.programForm.controls['IS_FUND_SUPPORT'].enable();
    if (event.value == "") {
      this.IsISTChecked = false;
      this.IsEAPChecked = false;
      this.ISGRANTSChecked = false;
      // this.DeleteAllMappro(this.MappedItems);
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(false);
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(false);
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.programForm.controls['PRODUCT_ID'].disable();
    }
    if (event.value == "2") {
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.IsISTChecked = true;
      this.IsEAPChecked = false;
      this.ISGRANTSChecked = false;
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(false);
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(false);
      this.programForm.controls['PRODUCT_ID'].disable();

    }
    if (event.value == "5") {
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.IsEAPChecked = true;
      this.IsISTChecked = false;
      this.ISGRANTSChecked = false;
      //this.DeleteAllMappro(this.MappedItems);
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(true);
      this.Isdisabled = true;
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(false);
      if (this.programForm.controls["IS_PRODUCT_SUPPORT"].value) {
        this.programForm.controls['PRODUCT_ID'].enable();
      }
      
      
    }
    if (event.value == "4") {
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.ISGRANTSChecked = true;
      this.IsISTChecked = false;
      this.IsEAPChecked = false;
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(true);
      this.programForm.controls["IS_FUND_SUPPORT"].disable();
      //this.Isdisabled = true;
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(false);
      this.programForm.controls['PRODUCT_ID'].disable();
      // this.DeleteAllMappro(this.MappedItems);
      
    }

  }

  getModulesList(): void {
    this.summaryService.getModuleList('api/common/getmoduleslist').subscribe((result) => {
      this.modulelist = result;
      this.modulelist= [{label:"Select",value:""}].concat(this.modulelist);
      //console.log(this.modulelist)
    });
  }


  IsproductAvaliable(event) {
    if (this.programForm.controls["IS_PRODUCT_SUPPORT"].value && this.isreferenced==false) {
      this.programForm.controls['PRODUCT_ID'].enable();
    }
    if (!this.programForm.controls["IS_PRODUCT_SUPPORT"].value) {
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.programForm.controls['PRODUCT_ID'].disable();
    }
  }
  // mapproducts() {
  //   if (this.programForm.controls["IS_PRODUCT_SUPPORT"].value) {
  //     if (this.programForm.controls["ID"].value == "") { this.strflag = "N" }
  //     else { this.strflag = "E" }
  //     let modalRef = this.modalService.show(AvailableProductsComponent, {
  //       backdrop: false,
  //       keyboard: false,
  //       ignoreBackdropClick: true,
  //       class: 'modal-vlg modal-full-height modal-right',
  //       animated: true,
  //       data: {
  //         heading: this.heading,
  //         content: { id: this.programForm.controls["ID"].value, flag: this.strflag, TargetScreen: "program" }
  //       }
  //     });
  //     modalRef.content.action.subscribe(result => {
  //       debugger
  //       //this.summaryService.getRecord('api/Product/GetMappedetworks?RecordID=' + this.productViewForm.controls["ID"].value).subscribe(summary => {
  //       this.MappedItems = result;
  //       //});
  //     });
  //   }
  // }


  private IsAutoCodeConfigured(): any {
    var featureid = "603";
    var orgid = this.userService.getOrganizationId();
    this.commonservice.isAutocodeConfigured(featureid, orgid).subscribe((result) => {
      if (result == true) {
        this.isautocode = true;
        //this.isautocodeDisabled = "";
      }
      else {
        this.isautocode = false;
        //if (this.heading === 'View' || this.heading === 'Edit')
        //  this.isautocodeDisabled = "disabled";
      }
    });
  }

  GetEditData(): void {
    this.summaryService.getRecord('api/AdminProgram/Edit?RecordID=' + this.Content.content.id).subscribe(summary => {
      //this.MappedItems= summary["MappedItems1"];
      if(summary["Modal"]["isrefered"]==true){
      this.programForm.controls['PROGRAM_ID'].disable();
      this.programForm.controls['PRODUCT_ID'].disable();
      this.programForm.controls['IS_FUND_SUPPORT'].disable();
      this.programForm.controls['IS_PRODUCT_SUPPORT'].disable();
      this.isreferenced = true;
      if(summary["MappedItems1"] != null && summary["MappedItems1"] != "" && summary["MappedItems1"] !=undefined )
       summary["MappedItems1"].forEach(element => {
         this.MappedItems.push(element.value);
       });
      }
      if ((summary["Modal"]["IS_FUND_SUPPORT"] && summary["Modal"]["IS_PRODUCT_SUPPORT"] && summary["Modal"]["isrefered"]==false)||(summary["Modal"]["IS_PRODUCT_SUPPORT"] && summary["Modal"]["isrefered"]==false)) {
        this.programForm.controls['PRODUCT_ID'].enable();
        summary["MappedItems1"].forEach(element => {
          this.MappedItems.push(element.value);
        });
      }
      else {
        this.programForm.controls['PRODUCT_ID'].disable();
      }
      if(summary["Modal"]["PROGRAM_ID"]=="4")
      {
        //Grants
        this.programForm.controls['IS_FUND_SUPPORT'].disable();
      }
      
      // if (summary["Modal"]["IS_PRODUCT_SUPPORT"]) {
      //   summary["MappedItems1"].forEach(element => {
      //     this.MappedItems.push(element.value);
      //   });
      // }


      this.programForm.patchValue({
        ID: summary["Modal"]["ID"],
        CODE: summary["Modal"]["CODE"],
        NAME: summary["Modal"]["NAME"],
        ACTIVECHECK: summary["Modal"]["RECORD_STATE"] == 1 ? true : false,
        DESCRIPTION: summary["Modal"]["DESCRIPTION"],
        IS_FUND_SUPPORT: summary["Modal"]["IS_FUND_SUPPORT"],
        IS_PRODUCT_SUPPORT: summary["Modal"]["IS_PRODUCT_SUPPORT"],
        PRODUCT_ID: this.MappedItems,
        PROGRAM_ID: summary["Modal"]["PROGRAM_ID"],
      });
      this.setProgramOption(this.programForm.controls['PROGRAM_ID'].value);
      if (this.Content.heading == "View") {
        this.programForm.disable();
      }
    });

  }
  // DeleteMappro(item): void {
  //   debugger;

  //   let index = this.MappedItems.findIndex((element) => element.value == item);
  //   this.MappedItems.splice(index, 1);
  //   //this.MappedItems = this.MappedItems.splice(this.MappedItems.indexOf(item, 1));
  // }
  // DeleteAllMappro(item):void{
  //   this.MappedItems=[];
  // }

  SaveProgram() {
   
    if (this.validateControls()) {
      var formDate = this.programForm.getRawValue();
      formDate.RECORD_STATE = this.programForm.controls["ACTIVECHECK"].value ? 1 : 0;
      formDate.MAPPED_PRODUCTS = formDate.PRODUCT_ID;
      if (formDate.PRODUCT_ID != null && formDate.PRODUCT_ID != "" && formDate.PRODUCT_ID != undefined && formDate.PRODUCT_ID.length>0) {
        let selectedids = formDate.MAPPED_PRODUCTS.join(",");
        let tempList = this.productlist.filter((item) => {
          return selectedids.indexOf(item.value) > -1;
        });
        tempList.forEach((obj, index) => {
          if (index == 0) {
            formDate.MAPPED_PRODUCTS = obj.value;
            formDate.MAPPEDPRODUCTNAME = obj.label;
          }
          else {
            formDate.MAPPED_PRODUCTS = formDate.MAPPED_PRODUCTS + "|" + obj.value;
            formDate.MAPPEDPRODUCTNAME = formDate.MAPPEDPRODUCTNAME + "," + obj.label;
          }
        });
      }
      else{
        formDate.MAPPED_PRODUCTS="";
      }
      if (this.Content.heading == "Add") {
        formDate["ID"] = this.Content.content.id;
        this.summaryService.Insert('api/AdminProgram/Insert', formDate).subscribe(summary => {
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Program Created Successfully.' } } });
          if (summary.Status == 0) {
            //this.action.next();
            this.modalRef.close();
            this.commonservice.SuccessBanner(summary.Message);
            this.programForm.controls["ID"].setValue(this.Content.content.id);
          }
          else {
            this.commonservice.ValidationBanner(summary.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: summary.Message } } });
          }
        });
      }
      else {
        this.summaryService.Insert('api/AdminProgram/Update', formDate).subscribe(summary => {
          if (summary.Status == 0) {
           // this.action.next();
            this.modalRef.close();
            this.commonservice.SuccessBanner(summary.Message);
          }
          else {
            this.commonservice.ValidationBanner(summary.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: summary.Message } } });
          }
        });
      }
    }

  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.programForm.getRawValue();

    if (formData.NAME === null || formData.NAME === "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Program Category<br/>";
      isValid = false;
    } else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (this.programForm.controls["PROGRAM_ID"].value== null || this.programForm.controls["PROGRAM_ID"].value== null ) {
      $("#MODULE_ID").addClass("ng-touched ng-invalid validate-error");
      $("#MODULE_ID").removeClass("ng-untouched ng-valid");
      message += "Please select Program<br/>";
      isValid = false;
    }
    else
    {
      if (this.programForm.controls["IS_PRODUCT_SUPPORT"].value)
      if (formData.PRODUCT_ID == null || formData.PRODUCT_ID == "") {
        {
          // if (this.MappedItems == null || this.MappedItems == "") {
          $("#PRODUCT_ID").addClass("ng-touched ng-invalid validate-error");
          $("#PRODUCT_ID").removeClass("ng-untouched ng-valid");
          message += "Please select Avaliable Products<br/>";
          isValid = false;
          //  }
        }
      }
      
    if (formData.IS_FUND_SUPPORT === false && formData.IS_PRODUCT_SUPPORT === false) {
      $("#IS_FUND_SUPPORT").addClass("ng-touched ng-invalid validate-error");
      $("#IS_FUND_SUPPORT").removeClass("ng-untouched ng-valid");
      message += "Please select at least program type<br/>";
      isValid = false;
    } else {
      $("#IS_FUND_SUPPORT").addClass("ng-untouched ng-valid");
      $("#IS_FUND_SUPPORT").removeClass("ng-touched ng-invalid validate-error");
    }
    
    }
    
    //else {
    //   $("#MODULE_ID").addClass("ng-untouched ng-valid");
    //   $("#MODULE_ID").removeClass("ng-touched ng-invalid validate-error");
    // }


    // if (formData.MAPPED_PRODUCTS == null || formData.MAPPED_PRODUCTS == "") {
    //   debugger
    //   $("#MAPPED_PRODUCTS").addClass("ng-touched ng-invalid validate-error");
    //   $("#MAPPED_PRODUCTS").removeClass("ng-untouched ng-valid");
    //   message += "Please select Avaliable Products.<br/>";
    //   isValid = false;
    // } else {
    //   $("#DESCRIPTION").addClass("ng-untouched ng-valid");
    //   $("#DESCRIPTION").removeClass("ng-touched ng-invalid validate-error");
    // }

    if (!isValid)
      this.commonservice.ValidationBanner(message);
    //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }
}
